import { AiProcessExecutionStatus, AiProcessStepExecutionStatus } from 'constants/aiProcessRuns';
import { StatusEnum } from 'constants/status';

export const STATUS_TO_TONE = {
  [AiProcessExecutionStatus.PENDING]: StatusEnum.INFO,
  [AiProcessExecutionStatus.RUNNING]: StatusEnum.IN_PROGRESS,
  [AiProcessExecutionStatus.AWAITING_CONFIRMATION]: StatusEnum.WARNING,
  [AiProcessExecutionStatus.AWAITING_USER_INPUT]: StatusEnum.WARNING,
  [AiProcessExecutionStatus.COMPLETED]: StatusEnum.SUCCESS,
  [AiProcessExecutionStatus.FAILED]: StatusEnum.ERROR,
  [AiProcessExecutionStatus.CANCELLED]: StatusEnum.WARNING,
  [AiProcessStepExecutionStatus.SKIPPED]: StatusEnum.INFO,
};

export const STATUS_LABELS = {
  [AiProcessExecutionStatus.PENDING]: 'Pending',
  [AiProcessExecutionStatus.RUNNING]: 'Running',
  [AiProcessExecutionStatus.AWAITING_CONFIRMATION]: 'Awaiting confirmation',
  [AiProcessExecutionStatus.AWAITING_USER_INPUT]: 'Awaiting input',
  [AiProcessExecutionStatus.COMPLETED]: 'Completed',
  [AiProcessExecutionStatus.FAILED]: 'Failed',
  [AiProcessExecutionStatus.CANCELLED]: 'Cancelled',
  [AiProcessStepExecutionStatus.SKIPPED]: 'Skipped',
};
